module.exports = __webpack_public_path__ + "static/media/ahi_dark_mode.a9c1dfa5.png";